module.exports = __webpack_public_path__ + "img/international-blue.433086dd.svg";